import { EEstimationTargets, EMyHomeEstimationTargets } from '@cian/valuation-main-filters-widget';
import { ca } from '@cian/analytics';
import { ITrackAddNewFlatByNumberParameters } from './types';

export const caMyHomeEventCategories: { [K in EMyHomeEstimationTargets]: string } = {
  [EEstimationTargets.flat]: 'MyHomeFlat',
  [EEstimationTargets.house]: 'MyHomeHouse',
  [EEstimationTargets.land]: 'MyHomeLand',
};

export function trackAddNewCard(estimationTarget: EMyHomeEstimationTargets) {
  ca('eventSite', {
    name: 'oldevent',
    category: caMyHomeEventCategories[estimationTarget],
    action: 'Click',
    label: 'EstateCalculator',
  });
}

export function trackAddNewFlatByNumberClick(parameters: ITrackAddNewFlatByNumberParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeFlat',
    action: 'Click',
    label: 'EstateCalculator',
    page: {
      pageType: 'MyHomeMainPage',
      siteType: 'desktop',
      extra: {
        parameters,
      },
    },
  });
}

export function trackAddNewFlatByNumberSubmit(parameters: ITrackAddNewFlatByNumberParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeFlat',
    action: 'Click',
    label: 'EstateCalculatorSuccess',
    page: {
      pageType: 'MyHomeMainPage',
      siteType: 'desktop',
      extra: {
        parameters,
      },
    },
  });
}
